<template>
  <field :label="label">
    <div class="control" :class="{ 'has-icons-right': error !== null }">
      <textarea class="textarea" :placeholder="holder" :type="type" :value="value" :readonly="readonly"
             :class="{ 'is-danger': error !== null }"
             @input="onInput"
             @keyup="onKeyup"
             @blur="onBlur"
             @focus="onFocus" :rows="rows"
             ref="input" />
      <span class="icon is-small is-right" v-if="error">
      <i class="fas fa-exclamation-triangle"></i>
    </span>
    </div>
    <p class="help is-danger" v-if="error">{{ error }}</p>
  </field>
</template>

<script>
import Field from '@/components/general/field'

export default {
  components: { Field },
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      defalut: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    error: {
      type: String,
      default: null
    },
    focus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 4
    }
  },
  computed: {
    holder () {
      if (this.placeholder) {
        return this.placeholder
      } else {
        return this.label
      }
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    },
    onKeyup (event) {
      this.$emit('keyup', event)
    },
    onBlur (event) {
      this.$emit('blur', event)
    },
    onFocus (event) {
      this.$emit('focus', event)
    }
  },
  mounted () {
    if (this.focus) {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
textarea{
  resize: none;
}
.field .control:only-child {
  margin-top: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/text-area.vue